module.exports = __webpack_public_path__ + "static/media/video-sleep-energisers-en.e7b005a5.vtt";